import React from 'react'

export default function About() {
  return (

    <section id="about" className="about">
      <div className="about-me container">
        <div className="section-title">
          <h2>About</h2>
          <p>Learn more about me</p>
        </div>
        <div className="row">
          <div className="col-lg-4" data-aos="fade-right">
            <img src="assets/img/kc.png" className="img-fluid" alt="" />
          </div>
          <div className="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
            <h3>Frontend Engineer</h3>
            <p className="fst-italic">
              Innovative Front End Developer with 4 years experience building and maintaining responsive websites, web and
              mobile applications in the
              financial, health-care and accounting industries.
            </p>
            <div className="row">
              <div className="col-lg-6">
                <ul>
                  <li><i className="bi bi-chevron-right"></i> <strong>Website:</strong> <span>https://kelechimbawuike.netlify.app</span></li>
                  <li><i className="bi bi-chevron-right"></i> <strong>Phone:</strong> <span>+234 706 134 1943</span></li>
                  <li><i className="bi bi-chevron-right"></i> <strong>City:</strong> <span>Lagos, Nigeria</span></li>
                </ul>
              </div>
              <div className="col-lg-6">
                <ul>
                  <li><i className="bi bi-chevron-right"></i> <strong>Degree:</strong> <span>Bacherlor</span></li>
                  <li><i className="bi bi-chevron-right"></i> <strong>Email:</strong> <span>kmbawuike@gmail.com</span></li>
                  <li><i className="bi bi-chevron-right"></i> <strong>Freelance:</strong> <span>Available</span></li>
                </ul>
              </div>
            </div>
            <p>
              Focused on making web content available for the underrepresented users of the internet by developing
              applications in compliance with W3C Web Standard, applying best practices, and most importantly leveraging
              on modern UI/Front- End libraries, frameworks, and tools such as HTML5, CSS3, JavaScript, React and React
              Native, etc. </p>
          </div>
        </div>

      </div>

      <div className="skills container">

        <div className="section-title">
          <h2>Skills</h2>
        </div>

        <div className="row skills-content">

          <div className="col-lg-6">

            <div className="progress">
              <span className="skill">HTML <i className="val">90%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100">
                </div>
              </div>
            </div>

            <div className="progress">
              <span className="skill">CSS <i className="val">85%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100">
                </div>
              </div>
            </div>

            <div className="progress">
              <span className="skill">JavaScript <i className="val">80%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">
                </div>
              </div>
            </div>

          </div>

          <div className="col-lg-6">

            <div className="progress">
              <span className="skill">React <i className="val">90%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100">
                </div>
              </div>
            </div>

            <div className="progress">
              <span className="skill">PHP & Laravel <i className="val">60%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100">
                </div>
              </div>
            </div>

            <div className="progress">
              <span className="skill">Ruby on Rails <i className="val">50%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow="55" aria-valuemin="0" aria-valuemax="100">
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>


      <div className="interests container">

        <div className="section-title">
          <h2>Interests</h2>
        </div>

        <div className="row">
          <div className="col-lg-3 col-md-4">
            <div className="icon-box">
              <i className="ri-code-s-slash-line" style={{ color: "#ffbb2c" }}></i>
              <h3>Coding</h3>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
            <div className="icon-box">
              <i className="ri-community-line" style={{ color: "#5578ff" }}></i>
              <h3>Community Dev.</h3>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
            <div className="icon-box">
              <i className="ri-football-line" style={{ color: "#e80368" }}></i>
              <h3>Football</h3>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 mt-4 mt-lg-0">
            <div className="icon-box">
              <i className="ri-run-line" style={{ color: "#e361ff" }}></i>
              <h3>Hiking</h3>
            </div>
          </div>


        </div>

      </div>


      <div className="testimonials container">

        <div className="section-title">
          <h2>Testimonials</h2>
        </div>

        <div className="testimonials-slider swiper" data-aos="fade-up" data-aos-delay="100">
          <div className="swiper-wrapper">

            <div className="swiper-slide">
              <div className="testimonial-item">
                <p>
                  <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                  Kelechi Mbawuike is very passionate and has a great vision for her work. Her focus keeps everything
                  moving
                  smoothly, she makes sure all the deadlines are met and makes sure that whatever project she is working
                  on meets the highest standards.
                  <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                </p>
                <img src="assets/img/testimonials/deji.jpeg" className="testimonial-img" alt="" />
                <h3>Ayodeji Ishola</h3>
                <h4>SCRUM Master (Octosoft Technologies)</h4>
              </div>
            </div>

            <div className="swiper-slide">
              <div className="testimonial-item">
                <p>
                  <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                  I have worked with Kelechi on multiple projects, one of the best frontend engineer I have worked with.
                  Kelechi is goal oriented, dedicated, has a great attitude and also very passionate about what he does.
                  Highly recommended.
                  <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                </p>
                <img src="assets/img/testimonials/ik.jpeg" className="testimonial-img" alt="" />
                <h3>Ikenna Umeanozie</h3>
                <h4>Senior Software Engineer (Andela)</h4>
              </div>
            </div>

            <div className="swiper-slide">
              <div className="testimonial-item">
                <p>
                  <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                  Kelechi is highly skilled in both web and mobile application development with fast learning abilities
                  and pays good attention to details
                  <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                </p>
                <img src="assets/img/testimonials/festus.jpeg" className="testimonial-img" alt="" />
                <h3>Festus Omole</h3>
                <h4>Software Engineer (JPMorgan Chase & Co.)</h4>
              </div>
            </div>

            <div className="swiper-slide">
              <div className="testimonial-item">
                <p>
                  <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                  Mbawuike Kelechi is a dedicated and passionate software developer whose attention to details is second
                  to none. He loves helping out every now and then. This fellow is fun working with.
                  <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                </p>
                <img src="assets/img/testimonials/jude.jpeg" className="testimonial-img" alt="" />
                <h3>Jude Nwafor</h3>
                <h4>Lead Frontend Engineer (Cyberspace NG.)</h4>
              </div>
            </div>

            <div className="swiper-slide">
              <div className="testimonial-item">
                <p>
                  <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                  Kelechi Mbawuike is one of the best among all people I have ever met and is a loyal colleague,
                  understands complex matters. Kelechi Mbawuike is a strong and goal-oriented team player; with every
                  problem, there was a solution. Highly recommended.
                  <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                </p>
                <img src="assets/img/testimonials/promise.jpeg" className="testimonial-img" alt="" />
                <h3>Promise Chukwuenyem</h3>
                <h4>Devops Engineer (ARCA Payments)</h4>
              </div>
            </div>

          </div>
          <div className="swiper-pagination"></div>
        </div>

        <div className="owl-carousel testimonials-carousel">

        </div>

      </div>


    </section>
  )
}
